import { render, staticRenderFns } from "./RequestViewTabChat.vue?vue&type=template&id=59e2386c"
import script from "./RequestViewTabChat.vue?vue&type=script&lang=js"
export * from "./RequestViewTabChat.vue?vue&type=script&lang=js"
import style0 from "./RequestViewTabChat.vue?vue&type=style&index=0&id=59e2386c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports